import { SVGProps } from 'react';

export default function EmbedIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = '#545454', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.77132 3.635C3.94706 3.81074 3.94706 4.09566 3.77132 4.2714L1.53952 6.5032L3.77132 8.735C3.94706 8.91074 3.94706 9.19566 3.77132 9.3714C3.59559 9.54713 3.31066 9.54713 3.13493 9.3714L0.584927 6.8214C0.409191 6.64566 0.409191 6.36074 0.584927 6.185L3.13493 3.635C3.31066 3.45926 3.59559 3.45926 3.77132 3.635ZM8.23493 3.635C8.41066 3.45926 8.69559 3.45926 8.87132 3.635L11.4213 6.185C11.5971 6.36074 11.5971 6.64566 11.4213 6.8214L8.87132 9.3714C8.69559 9.54713 8.41066 9.54713 8.23493 9.3714C8.05919 9.19566 8.05919 8.91074 8.23493 8.735L10.4667 6.5032L8.23493 4.2714C8.05919 4.09566 8.05919 3.81074 8.23493 3.635Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.82958 1.70974C7.0745 1.75197 7.23881 1.98474 7.19658 2.22966L5.69658 10.9297C5.65436 11.1746 5.42158 11.3389 5.17667 11.2967C4.93175 11.2544 4.76744 11.0217 4.80967 10.7767L6.30967 2.07674C6.35189 1.83183 6.58467 1.66751 6.82958 1.70974Z"
        fill={fill}
      />
    </svg>
  );
}
